export default class BaseController {
    /**
     * 
     * @param {String} selector CSS selector to select the container to give to an Instance
     * @param {Class} instance Class/object that will be created when selector matches
     * @param {Document|Element} scope Scope of where to search for the selector
     */
    constructor(selector = null, instance = null, scope = document) {
        this.instances = [];

        this.selector = selector;
        this.Instance = instance;
        this.scope = scope;

        if (this.Instance && this.selector) {
            this.init();
        }
    }

    init() {
        if (this.scope.querySelectorAll(this.selector).length) {
            this.scope.querySelectorAll(this.selector).forEach(container => {
                const instance = new this.Instance(container);
                this.instances.push(instance);

                instance.init();
            });
        }
    }
}